import type { AmbitoId } from './ambitiStats'

export type PnrrAmbito = AmbitoId | 'provinciale'

export interface PnrrIntervento {
  areaProvinciale: string
  luogo: string
  missione: string
  componente: string
  codiceTitoloSubmisura: string
  descrizioneIntervento: string
  interventiPrevisti: string
  risorsePreviste: string
  ambito: PnrrAmbito
}

export const PNRR_INTERVENTI: PnrrIntervento[] = [
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Agrate Brianza",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.1 - Case della Comunità e presa in carico della persona",
    "descrizioneIntervento": "Realizzazione Casa Di Comunita (Cdc ) Pr",
    "interventiPrevisti": "1",
    "risorsePreviste": "1577519",
    "ambito": "vimercate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Bellusco",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.1 - Case della Comunità e presa in carico della persona",
    "descrizioneIntervento": "Realizzazione Casa Di Comunita Presso L'",
    "interventiPrevisti": "1",
    "risorsePreviste": "1404828",
    "ambito": "vimercate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Besana In Brianza",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.1 - Case della Comunità e presa in carico della persona",
    "descrizioneIntervento": "Realizzazione Casa Della Comunita Presso",
    "interventiPrevisti": "1",
    "risorsePreviste": "2100000",
    "ambito": "carate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Besana In Brianza",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.2.2 - Implementazione delle Centrali operative territoriali (COT)",
    "descrizioneIntervento": "Realizzazione Cot Presso La Struttura Di",
    "interventiPrevisti": "1",
    "risorsePreviste": "24563",
    "ambito": "carate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Brugherio",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.1 - Case della Comunità e presa in carico della persona",
    "descrizioneIntervento": "Realizzazione Casa Di Comunita' Via Kenn",
    "interventiPrevisti": "1",
    "risorsePreviste": "1331059",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Brugherio",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.2.2 - Implementazione delle Centrali operative territoriali (COT)",
    "descrizioneIntervento": "Realizzazione Cot Transitoria Presso L'Immobile Di V.Le Lombardia N. 270 Brugherio Via Lombardia N.270 Realizzazione Cot Transitoria Presso L'Immobile Di V.Le Lombardia N. 270 Brugherio",
    "interventiPrevisti": "1",
    "risorsePreviste": "0",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Brugherio",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.2.2 - Implementazione delle Centrali operative territoriali (COT)",
    "descrizioneIntervento": "Realizzazione Cto (Centro Operativo Terr",
    "interventiPrevisti": "1",
    "risorsePreviste": "149541",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Carate Brianza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.1 - Ammodernamento del parco tecnologico e digitale ospedaliero (Digitalizzazione)",
    "descrizioneIntervento": "Adeguamento Tecnologico Via Mose' Bianch",
    "interventiPrevisti": "1",
    "risorsePreviste": "146400",
    "ambito": "carate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Carate Brianza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Mammografo Presidio Di Carate Brianza Vi",
    "interventiPrevisti": "1",
    "risorsePreviste": "260000",
    "ambito": "carate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Carate Brianza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.1 - Ammodernamento del parco tecnologico e digitale ospedaliero (Digitalizzazione)",
    "descrizioneIntervento": "Ristrutturazione/Ampliamento In Continui",
    "interventiPrevisti": "1",
    "risorsePreviste": "831777",
    "ambito": "carate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Carate Brianza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Telecomandato Digitale Presidio Di Carat",
    "interventiPrevisti": "1",
    "risorsePreviste": "247700",
    "ambito": "carate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Cesano Maderno",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.1 - Case della Comunità e presa in carico della persona",
    "descrizioneIntervento": "Realizzazione Casa Della Comunita Presso",
    "interventiPrevisti": "1",
    "risorsePreviste": "1970305",
    "ambito": "desio"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Desio",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Angiografo Presidio Di Desio Via Giusepp",
    "interventiPrevisti": "1",
    "risorsePreviste": "615974",
    "ambito": "desio"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Desio",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Ecotomografo Presidio Di Desio Ginecolog",
    "interventiPrevisti": "1",
    "risorsePreviste": "62039",
    "ambito": "desio"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Desio",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.1 - Ammodernamento del parco tecnologico e digitale ospedaliero (Digitalizzazione)",
    "descrizioneIntervento": "Evoluzione Della Cartella Clinica Elettr",
    "interventiPrevisti": "1",
    "risorsePreviste": "3050000",
    "ambito": "desio"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Desio",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.1 - Ammodernamento del parco tecnologico e digitale ospedaliero (Digitalizzazione)",
    "descrizioneIntervento": "Gestione Tecnica Patrimoniale Via Mazzin",
    "interventiPrevisti": "1",
    "risorsePreviste": "499116",
    "ambito": "desio"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Desio",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.1 - Case della Comunità e presa in carico della persona",
    "descrizioneIntervento": "Realizzazione Casa Della Comunita Presso",
    "interventiPrevisti": "1",
    "risorsePreviste": "1948539",
    "ambito": "desio"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Desio",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.2.2 - Implementazione delle Centrali operative territoriali (COT)",
    "descrizioneIntervento": "Realizzazione Cot Presso L'Immobile Di D",
    "interventiPrevisti": "1",
    "risorsePreviste": "102549",
    "ambito": "desio"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Desio",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Tomografo A Risonanza Magnetica Presidio",
    "interventiPrevisti": "1",
    "risorsePreviste": "925987",
    "ambito": "desio"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Giussano",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.1 - Case della Comunità e presa in carico della persona",
    "descrizioneIntervento": "Realizzazione Casa Di Comunita' Presso L",
    "interventiPrevisti": "1",
    "risorsePreviste": "1415325",
    "ambito": "seregno"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Giussano",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.2.2 - Implementazione delle Centrali operative territoriali (COT)",
    "descrizioneIntervento": "Realizzazione Cot Presso La Struttura Di",
    "interventiPrevisti": "1",
    "risorsePreviste": "22746",
    "ambito": "seregno"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Giussano",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.3 - Rafforzamento dell'assistenza sanitaria intermedia e delle sue strutture (Ospedali di Comunità)",
    "descrizioneIntervento": "Realizzazione Ospedale Della Comunita Pr",
    "interventiPrevisti": "1",
    "risorsePreviste": "1822831",
    "ambito": "seregno"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Giussano",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Telecomandato Digitale Presidio Di Giuss",
    "interventiPrevisti": "1",
    "risorsePreviste": "247700",
    "ambito": "seregno"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Lentate Sul Seveso",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.1 - Case della Comunità e presa in carico della persona",
    "descrizioneIntervento": "Realizzazione Cdc Hub Presso L'Immobile",
    "interventiPrevisti": "1",
    "risorsePreviste": "1515215",
    "ambito": "seregno"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Limbiate",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.1 - Case della Comunità e presa in carico della persona",
    "descrizioneIntervento": "Realizzazione Casa Della Comunita Presso",
    "interventiPrevisti": "1",
    "risorsePreviste": "1047082",
    "ambito": "desio"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Limbiate",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.2.2 - Implementazione delle Centrali operative territoriali (COT)",
    "descrizioneIntervento": "Realizzazione Cot Presso L'Immobile Di L",
    "interventiPrevisti": "1",
    "risorsePreviste": "55106",
    "ambito": "desio"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Limbiate",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.3 - Rafforzamento dell'assistenza sanitaria intermedia e delle sue strutture (Ospedali di Comunità)",
    "descrizioneIntervento": "Realizzazione Di Ospedale Di Comunita Pr",
    "interventiPrevisti": "1",
    "risorsePreviste": "5005349",
    "ambito": "desio"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Lissone",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.1 - Case della Comunità e presa in carico della persona",
    "descrizioneIntervento": "Realizzazione Casa Della Comunita Presso",
    "interventiPrevisti": "1",
    "risorsePreviste": "1852466",
    "ambito": "carate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Lissone",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.2.2 - Implementazione delle Centrali operative territoriali (COT)",
    "descrizioneIntervento": "Realizzazione Cot Presso La Struttura Di",
    "interventiPrevisti": "1",
    "risorsePreviste": "97494",
    "ambito": "carate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Macherio",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.1 - Case della Comunità e presa in carico della persona",
    "descrizioneIntervento": "Realizzazione Cdc Spoke Presso L'Immobil",
    "interventiPrevisti": "1",
    "risorsePreviste": "209159",
    "ambito": "carate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I2.1 - Rafforzamento e potenziamento della ricerca biomedica del SSN",
    "descrizioneIntervento": "Against Ad 2 - Addressing Brain Cholest",
    "interventiPrevisti": "1",
    "risorsePreviste": "304581",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.1 - Case della Comunità e presa in carico della persona",
    "descrizioneIntervento": "Casa Di Comunita' Hub Via Solferino 16 M",
    "interventiPrevisti": "1",
    "risorsePreviste": "1331852",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.1 - Ammodernamento del parco tecnologico e digitale ospedaliero (Digitalizzazione)",
    "descrizioneIntervento": "Da Definire",
    "interventiPrevisti": "2",
    "risorsePreviste": "103700",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I2.1 - Rafforzamento e potenziamento della ricerca biomedica del SSN",
    "descrizioneIntervento": "Development And Validation Of Novel Meth",
    "interventiPrevisti": "1",
    "risorsePreviste": "303220",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I2.1 - Rafforzamento e potenziamento della ricerca biomedica del SSN",
    "descrizioneIntervento": "Effect Of Infections And Global Dna Methylation On Frailty Trajectories In Hospitalized Older Patients: A Multicenter Observational Study",
    "interventiPrevisti": "1",
    "risorsePreviste": "65000",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I2.1 - Rafforzamento e potenziamento della ricerca biomedica del SSN",
    "descrizioneIntervento": "Genotypic Metabolic And Immunophenotyp",
    "interventiPrevisti": "1",
    "risorsePreviste": "200000",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.1 - Ammodernamento del parco tecnologico e digitale ospedaliero (Digitalizzazione)",
    "descrizioneIntervento": "Gestione Tecnico Patrimoniale*Via Pergolesi 33* Realizzazione Di Nuovi 20 Posti Letto Di Terapia Intensiva C/O Il P.O. Di Monza Via Pergolesi 33",
    "interventiPrevisti": "1",
    "risorsePreviste": "4506506",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I2.2.B - Sviluppo delle competenze tecniche-professionali, digitali e manageriali del personale del sistema sanitario: Sub-misura: corso di formazione in infezioni ospedaliere",
    "descrizioneIntervento": "Infezioni_Ospedaliere_Ats-Brianza",
    "interventiPrevisti": "1",
    "risorsePreviste": "40916",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Ingegneria Clinica Via Pergolesi 33 Acce",
    "interventiPrevisti": "1",
    "risorsePreviste": "2100000",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Ingegneria Clinica Via Pergolesi 33 Angi",
    "interventiPrevisti": "1",
    "risorsePreviste": "608000",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.1 - Ammodernamento del parco tecnologico e digitale ospedaliero (Digitalizzazione)",
    "descrizioneIntervento": "Ingegneria Clinica Via Pergolesi 33 Digi",
    "interventiPrevisti": "1",
    "risorsePreviste": "9850000",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Ingegneria Clinica Via Pergolesi 33 Ecot",
    "interventiPrevisti": "4",
    "risorsePreviste": "303189",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Ingegneria Clinica Via Pergolesi 33 Gamm",
    "interventiPrevisti": "2",
    "risorsePreviste": "1293000",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Ingegneria Clinica Via Pergolesi 33 Mamm",
    "interventiPrevisti": "1",
    "risorsePreviste": "260000",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Ingegneria Clinica Via Pergolesi 33 Tomo",
    "interventiPrevisti": "2",
    "risorsePreviste": "1438811",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I2.1 - Rafforzamento e potenziamento della ricerca biomedica del SSN",
    "descrizioneIntervento": "Italian Autoimmune Liver Disease (It-Aild) Clinical Research Network (Crn)",
    "interventiPrevisti": "1",
    "risorsePreviste": "334683",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.1 - Ammodernamento del parco tecnologico e digitale ospedaliero (Digitalizzazione)",
    "descrizioneIntervento": "Opere Per Il Riassetto Area Ingresso Con",
    "interventiPrevisti": "1",
    "risorsePreviste": "173194",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.3 - Rafforzamento dell'assistenza sanitaria intermedia e delle sue strutture (Ospedali di Comunità)",
    "descrizioneIntervento": "Ospedale Di Comunita' Hub Via Solferino",
    "interventiPrevisti": "1",
    "risorsePreviste": "6042133",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I2.1 - Rafforzamento e potenziamento della ricerca biomedica del SSN",
    "descrizioneIntervento": "Prospectivepreclinicalandclinicalstudiesofgutmicrobiota Intestinalbarrier Andrelatedbloodmetabolites Followingtraumaticbraininjuryfordevelopingprognosticbiomarkersofchronicneurologicalsequelae Andforidentifyingtargetstopreventtheprogressiveevolutionofbrai",
    "interventiPrevisti": "1",
    "risorsePreviste": "150000",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.1 - Case della Comunità e presa in carico della persona",
    "descrizioneIntervento": "Realizzazione Casa Di Comunita' Via Oria",
    "interventiPrevisti": "1",
    "risorsePreviste": "1480600",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.1 - Case della Comunità e presa in carico della persona",
    "descrizioneIntervento": "Realizzazione Casa Di Comunita' Viale Ro",
    "interventiPrevisti": "1",
    "risorsePreviste": "1480600",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.2.2 - Implementazione delle Centrali operative territoriali (COT)",
    "descrizioneIntervento": "Realizzazione Cto (Centro Operativo Terr",
    "interventiPrevisti": "1",
    "risorsePreviste": "149629",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Monza",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.2.2 - Implementazione delle Centrali operative territoriali (COT)",
    "descrizioneIntervento": "S.C. Gestione Tecnico Patrimoniale Via Pergolesi 33 Fornitura Arredi E Segnaletica",
    "interventiPrevisti": "1",
    "risorsePreviste": "0",
    "ambito": "monza"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Nova Milanese",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.1 - Case della Comunità e presa in carico della persona",
    "descrizioneIntervento": "Realizzazione Cdc Hub Presso L'Immobile",
    "interventiPrevisti": "1",
    "risorsePreviste": "518602",
    "ambito": "desio"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Provincia Di Monza E Della Brianza",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "E - Ecosistema innovativo della salute",
    "descrizioneIntervento": "Non Disponibile",
    "interventiPrevisti": "1",
    "risorsePreviste": "2100000",
    "ambito": "provinciale"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Seregno",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Mammografo Presidio Di Seregno Via Giuse",
    "interventiPrevisti": "1",
    "risorsePreviste": "260000",
    "ambito": "seregno"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Seregno",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.1 - Case della Comunità e presa in carico della persona",
    "descrizioneIntervento": "Realizzazione Casa Della Comunita Presso",
    "interventiPrevisti": "1",
    "risorsePreviste": "2100000",
    "ambito": "seregno"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Vimercate",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.1 - Ammodernamento del parco tecnologico e digitale ospedaliero (Digitalizzazione)",
    "descrizioneIntervento": "Adeguamento Tecnologico Via Santi Cosma",
    "interventiPrevisti": "1",
    "risorsePreviste": "29280",
    "ambito": "vimercate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Vimercate",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.1 - Ammodernamento del parco tecnologico e digitale ospedaliero (Digitalizzazione)",
    "descrizioneIntervento": "Da Definire",
    "interventiPrevisti": "2",
    "risorsePreviste": "1141296",
    "ambito": "vimercate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Vimercate",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Ecotomografo Presidio Di Vimercate Cardi",
    "interventiPrevisti": "1",
    "risorsePreviste": "82000",
    "ambito": "vimercate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Vimercate",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Ecotomografo Presidio Di Vimercate Ginec",
    "interventiPrevisti": "1",
    "risorsePreviste": "38513",
    "ambito": "vimercate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Vimercate",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Ecotomografo Presidio Di Vimercate Medi",
    "interventiPrevisti": "1",
    "risorsePreviste": "82000",
    "ambito": "vimercate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Vimercate",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Ecotomografo Presidio Di Vimercate Radio",
    "interventiPrevisti": "1",
    "risorsePreviste": "82000",
    "ambito": "vimercate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Vimercate",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.1 - Ammodernamento del parco tecnologico e digitale ospedaliero (Digitalizzazione)",
    "descrizioneIntervento": "Evoluzione Della Cartella Clinica Elettr",
    "interventiPrevisti": "1",
    "risorsePreviste": "4050000",
    "ambito": "vimercate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Vimercate",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I2.2.B - Sviluppo delle competenze tecniche-professionali, digitali e manageriali del personale del sistema sanitario: Sub-misura: corso di formazione in infezioni ospedaliere",
    "descrizioneIntervento": "Infezioni_Ospedaliere_Asst-Brianza",
    "interventiPrevisti": "1",
    "risorsePreviste": "545540",
    "ambito": "vimercate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Vimercate",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Ortopantomografo Presidio Di Vimercate V",
    "interventiPrevisti": "1",
    "risorsePreviste": "36600",
    "ambito": "vimercate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Vimercate",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.1 - Ammodernamento del parco tecnologico e digitale ospedaliero (Digitalizzazione)",
    "descrizioneIntervento": "P.O Vimercate - Moduli Terapia Intensiva",
    "interventiPrevisti": "1",
    "risorsePreviste": "220575",
    "ambito": "vimercate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Vimercate",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.1 - Case della Comunità e presa in carico della persona",
    "descrizioneIntervento": "Realizzazione Casa Della Comunita Presso",
    "interventiPrevisti": "1",
    "risorsePreviste": "91080",
    "ambito": "vimercate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Vimercate",
    "missione": "M6",
    "componente": "C1",
    "codiceTitoloSubmisura": "I1.2.2 - Implementazione delle Centrali operative territoriali (COT)",
    "descrizioneIntervento": "Realizzazione Cot Ubicata Presso L'Immob",
    "interventiPrevisti": "1",
    "risorsePreviste": "15395",
    "ambito": "vimercate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Vimercate",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Sistema Polifunzionale Per Radiologia Di",
    "interventiPrevisti": "2",
    "risorsePreviste": "561200",
    "ambito": "vimercate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Vimercate",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Telecomandato Digitale Presidio Di Vimer",
    "interventiPrevisti": "1",
    "risorsePreviste": "247700",
    "ambito": "vimercate"
  },
  {
    "areaProvinciale": "Monza E Della Brianza",
    "luogo": "Vimercate",
    "missione": "M6",
    "componente": "C2",
    "codiceTitoloSubmisura": "I1.1.2 - Ammodernamento del parco tecnologico e digitale ospedaliero (grandi apprecchiature)",
    "descrizioneIntervento": "Tomografo A Risonanza Magnetica -Presidi",
    "interventiPrevisti": "1",
    "risorsePreviste": "957487",
    "ambito": "vimercate"
  }
]
